var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"policy_system_main"},[_c('div',{staticClass:"banner"},[_c('sys_logo',{attrs:{"name":"物联网监测管理"}}),_vm._v(" "),_c('sys_cur_user')],1),_vm._v(" "),_c('router-view',{staticStyle:{"background-color":"#EFF0F3","width":"100%","height":"calc(100% - 60px)"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3be4ea75","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/studio/new_cockpit_box/cockpit_children/wlwyzt_cockpit/wlwyzt_asset/wlwyzt_asset_main.vue
// module id = null
// module chunks = 